import { MergeDeep } from 'utils';
import { FetchCardapioApi } from './fetch-cardapio-api';
import { replaceAll } from 'utils/replace-all';
import { useObterToken } from 'services/store/obter-token';

export const FetchCardapioApiAsMasterUser = (
  path: RequestInfo,
  options?: RequestInit,
): Promise<Response> => {

  const vToken = useObterToken.getState().token;

  const Default: RequestInit = {
    headers: {
      Authorization: vToken ? `Bearer ${replaceAll(vToken, `"`, '')}` : '',
      'Domain': 'app.touchone.com.br',
    },
  };
  return FetchCardapioApi(path, MergeDeep(Default, options));
};

export const FetchCardapioApiAsMasterUserJSON = <Tipo = any>(
  path: RequestInfo,
  options?: RequestInit,
) => {
  return FetchCardapioApiAsMasterUser(path, options).then(
    (response) => response.json() as Promise<Tipo>,
  );
};
